/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { addAlert } from 'store/actions/alert/alerts';
import { authGetRequest, authPatchRequestWithParam } from 'helpers/apiRequests';
import InsideLoader from 'components/common/InsideLoader';

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { formStyles } from 'consts/styles/Form';
import EachSideAdminContentHandler from 'components/user/admin/users/EachSideAdminContentHandler';
import Common from './forms/Common';
import Utm from './forms/Utm';
import Core from './forms/Core';
import Atam from './forms/Atam';

const a11yProps = index => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

const MainSystemSettings = () => {
  const [whichForm, setWhichForm] = React.useState(null);
  const [settings, setSettings] = React.useState(null);

  const dispatch = useDispatch();

  const [value, setValue] = React.useState(0);

  const subtitlesAlerts = useSelector(state => state.language.alerts);
  const subtitles = useSelector(
    state => state.language.adminZone.systemSettings
  );

  const apiGetSettings = () => {
    authGetRequest('systemSettings').then(result => {
      if (result.status === 200) {
        setSettings(result.data);
      } else
        dispatch(
          addAlert({
            title: subtitlesAlerts[result.status].title_,
            desc: subtitlesAlerts[result.status].desc_,
            type: 'error',
          })
        );
    });
  };

  React.useEffect(() => {
    apiGetSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setNewSettings = (service, values) => {
    setSettings([
      ...settings.map(item =>
        item.service === service ? { ...item, configuration: values } : item
      ),
    ]);
  };

  const saveSettings = async (service, newSettings) => {
    const { uid } = settings.find(item => item.service === service);
    delete newSettings.topic;
    delete newSettings.service;
    const result = await authPatchRequestWithParam(
      'systemSettings',
      uid,
      newSettings
    );
    if (result.status === 200) {
      setNewSettings(service, newSettings);
      setWhichForm(null);
      dispatch(
        addAlert({
          title: subtitlesAlerts.addDataSuccess.title_,
          desc: subtitlesAlerts.addDataSuccess.desc_,
          type: 'success',
        })
      );
    } else {
      dispatch(
        addAlert({
          title: subtitlesAlerts[result.status].title_,
          desc: subtitlesAlerts[result.status].desc_,
          type: 'error',
        })
      );
    }
  };

  const formClasses = formStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabsAction = React.useRef();

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      tabsAction.current.updateIndicator();
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [Common, Utm, Core, Atam]);

  return (
    <div>
      <div>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          indicatorColor="primary"
          variant="fullWidth"
          centered
          classes={{
            root: `${formClasses.Form}__text-field`,
            indicator: `${formClasses.Form}__tabs__button`,
          }}
          action={tabsAction}
        >
          <Tab label={subtitles.common.common_} {...a11yProps(0)} />
          <Tab label={subtitles.utm.utm_} {...a11yProps(1)} />
          <Tab label={subtitles.core.core_} {...a11yProps(2)} />
          <Tab label={subtitles.atam.atam_} {...a11yProps(4)} />
        </Tabs>
      </div>

      {!settings && !whichForm ? (
        <InsideLoader />
      ) : (
        <>
          <EachSideAdminContentHandler value={value} index={0}>
            <Common
              settings={
                settings.find(service => service.service === 'COMMON')
                  ?.configuration
              }
              save={saveSettings}
            />
          </EachSideAdminContentHandler>
          <EachSideAdminContentHandler value={value} index={1}>
            <Utm
              settings={
                settings.find(service => service.service === 'UTM')
                  ?.configuration
              }
              save={saveSettings}
            />
          </EachSideAdminContentHandler>
          <EachSideAdminContentHandler value={value} index={2}>
            <Core
              settings={
                settings.find(service => service.service === 'CORE')
                  ?.configuration
              }
              save={saveSettings}
            />
          </EachSideAdminContentHandler>
          <EachSideAdminContentHandler value={value} index={3}>
            <Atam
              settings={
                settings.find(service => service.service === 'ATAM')
                  ?.configuration
              }
              save={saveSettings}
            />
          </EachSideAdminContentHandler>
        </>
      )}
    </div>
  );
};

export default MainSystemSettings;
